<template>
    <div>
        <v-row v-if="loading">
            <v-col cols="12" md="7">
                <v-skeleton-loader
                    type="heading, table-row@3, button"
                ></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-card v-if="!loading">
            <v-card-text>
                <form>
                    <v-row>
                        <v-col cols="12" xl="9">
                            <v-row v-if="request !== null">
                                <v-col>
                                    <v-text-field :value="form.id" disabled="disabled" label="ID"></v-text-field>
                                </v-col>
                                <v-col sm="auto" v-if="$helper.permission.canSeeScore(user)" class="pt-3">
                                    <div class="text-caption grey--text">Скоринг</div>
                                    <v-chip v-if="request.scoringEnabled === false" outlined color="grey"
                                            title="Скоринг для подразделения отключен">отключен</v-chip>
                                    <v-chip v-else-if="score !== null && score !== undefined"
                                            dark :color="$helper.aiScoreColor(score.score)"
                                            @click="dialog.scoreDetail.modal = true">
                                        {{ score.score }}
                                    </v-chip>
                                    <v-progress-circular v-else-if="request.scorePending" indeterminate size="18" width="2"
                                                          color="grey" title="Скоринг ещё считается"></v-progress-circular>
                                    <v-icon v-else small color="grey"
                                            title="Пока не понятно, о чём заявка — не было ещё первого контакта, ждём">mdi-account-question-outline</v-icon>
                                </v-col>
                                <v-col>
                                    <v-autocomplete
                                        v-model="form.state"
                                        :items="states"
                                        :disabled="!isManualDrivenState(form.state) && !$helper.permission.canChangeNotManualState(user, form.state)"
                                        v-on:change="onChangeState"
                                        label="Статус">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('state')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('state') }}
                                    </v-alert>
                                    <div v-if="isFailureState(form.state)">
                                        <v-autocomplete
                                            v-model="form.failureReason"
                                            :items="failureReasons"
                                            return-object
                                            label="Причина"
                                            :clearable="true">
                                        </v-autocomplete>
                                        <v-text-field
                                            v-model="form.failureComment"
                                            label="Комментарий к причине">
                                        </v-text-field>
                                    </div>
                                    <div v-if="request.appointmentDate">
                                        <v-row>
                                            <v-col>
                                                <v-text-field :value="request.appointmentDate" disabled></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                    :value="request.appointmentTime.text"
                                                    disabled>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                                <v-col sm="auto">
                                    <AppointmentDialog
                                        v-if="$helper.permission.canMakeAppointments(user)"
                                        :id="form.id"
                                        :request="request"
                                        :isNewAppointment="!request.appointmentDate"
                                        :offices="page.offices"
                                        @saved="onAppointmentAdd">
                                    </AppointmentDialog>
                                </v-col>
                                <v-col sm="auto" v-if="request.appointmentDate && request.state !== 'CANCEL_ZAPIS'">
                                    <div v-if="$helper.permission.canMakeAppointments(user)">
                                        <v-dialog v-model="dialog.cancelAppointment.modal" max-width="400">
                                            <template v-slot:activator="{ on }">
                                                <v-btn outlined color="red" v-on="on">
                                                    <v-icon left>mdi-cancel</v-icon>
                                                    Отменить запись
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>Отменить запись</v-card-title>
                                                <v-card-text>
                                                    <v-autocomplete
                                                        v-model="dialog.cancelAppointment.failureReason"
                                                        :items="failureReasons"
                                                        return-object
                                                        label="Причина"
                                                        :clearable="true">
                                                    </v-autocomplete>
                                                    <v-text-field
                                                        v-model="dialog.cancelAppointment.failureComment"
                                                        label="Комментарий к причине">
                                                    </v-text-field>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text @click="dialog.cancelAppointment.modal = false">Закрыть</v-btn>
                                                    <v-btn color="red" text
                                                           :disabled="!dialog.cancelAppointment.failureReason"
                                                           @click="cancelAppointment">
                                                        Отменить запись
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                    <div class="mt-3" v-if="!request.appointmentApproved">
                                        <v-btn outlined color="green" @click="approveAppointment">
                                            <v-icon left>mdi-check</v-icon>
                                            Подтвердить запись
                                        </v-btn>
                                    </div>
                                    <div class="mt-3" v-if="request.appointmentApproved">
                                        <v-btn outlined color="green" @click="cancelApproveAppointment">
                                            <v-icon small left>mdi-check</v-icon>
                                            Запись подтверждена
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col v-if="$helper.permission.canSeeSourceOfRequest(user) || !request">
                                    <v-autocomplete
                                        v-model="form.source"
                                        :items="sources"
                                        item-value="id"
                                        :disabled="request !== null"
                                        item-text="name"
                                        label="Источник"
                                        :clearable="true">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('source')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('source') }}
                                    </v-alert>
                                </v-col>
                                <v-col v-if="$helper.permission.canChangeSubdivision(user)">
                                    <v-autocomplete
                                        v-model="form.subdivision"
                                        label="Подразделение"
                                        :items="subdivisions"
                                        item-value="id"
                                        item-text="name"
                                        :clearable="true">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('subdivision')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('subdivision') }}
                                    </v-alert>
                                </v-col>
                                <v-col v-if="$helper.permission.canAssignRequest(user)">
                                    <v-autocomplete
                                        v-model="form.operator"
                                        label="Оператор"
                                        :items="operators"
                                        item-value="id"
                                        item-text="fullName"
                                        :clearable="true">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('operator')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('operator') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="request !== null">
                                <v-col v-if="$helper.permission.canSeeCreatedAtOfRequest(user)">
                                    <v-text-field
                                        :value="form.createdAt"
                                        disabled="disabled"
                                        label="Дата создания">
                                    </v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        :value="form.assignedAt"
                                        disabled="disabled"
                                        label="Дата привязки">
                                    </v-text-field>
                                </v-col>
                                <v-col v-if="$helper.permission.canAssignCounterpart(user)">
                                    <v-autocomplete
                                        v-model="form.counterpart"
                                        label="Контрагент"
                                        :items="counterparts"
                                        item-value="id"
                                        item-text="fullName"
                                        :clearable="true">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('counterpart')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('counterpart') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="form.userName" label="Имя"></v-text-field>
                                    <v-alert v-if="form.errors.has('userName')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('userName') }}
                                    </v-alert>
                                </v-col>
                                <v-col>
                                    <v-row align="center" style="margin-top: -12px; margin-bottom: -12px">
                                        <v-col>
                                            <v-text-field
                                                data-test="field-phone"
                                                v-model="form.userPhone"
                                                label="Телефон"
                                                v-mask="'+7 (###) ###-##-## #'">
                                            </v-text-field>
                                            <v-alert v-if="form.errors.has('userPhone')" dense outlined type="error" :icon="false">
                                                {{ form.errors.get('userPhone') }}
                                            </v-alert>
                                        </v-col>
                                        <v-col class="col-auto" v-if="form.userPhone">
                                            <a :href="`tel:${form.userPhone}`" style="text-decoration: none">
                                                <v-btn small outlined color="green">
                                                    <v-icon left small style="margin: 0">mdi-phone</v-icon>
                                                </v-btn>
                                            </a>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col>
                                    <v-row align="center" style="margin-top: -12px; margin-bottom: -12px">
                                        <v-col>
                                            <v-text-field
                                                v-model="form.additionalUserPhone"
                                                label="Доп. телефон"
                                                v-mask="'+7 (###) ###-##-## #'">
                                            </v-text-field>
                                            <v-alert v-if="form.errors.has('additionalUserPhone')" dense outlined type="error" :icon="false">
                                                {{ form.errors.get('additionalUserPhone') }}
                                            </v-alert>
                                        </v-col>
                                        <v-col class="col-auto" v-if="form.additionalUserPhone">
                                            <a :href="`tel:${form.additionalUserPhone}`" style="text-decoration: none">
                                                <v-btn small outlined color="green">
                                                    <v-icon left small style="margin: 0">mdi-phone</v-icon>
                                                </v-btn>
                                            </a>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="form.userEmail" label="Email"></v-text-field>
                                    <v-alert v-if="form.errors.has('userEmail')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('userEmail') }}
                                    </v-alert>
                                </v-col>
                                <v-col v-if="form.userIp">
                                    <v-text-field v-model="form.userIp" label="Ip" disabled=""></v-text-field>
                                    <v-alert v-if="form.errors.has('userIp')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('userIp') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        v-model="form.area"
                                        :items="areas"
                                        item-value="id"
                                        item-text="name"
                                        label="Область права"
                                        required
                                        :clearable="false">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('area') || form.errors.has('areaNotEmptyWhenOperatorNotNull')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('area') ?? form.errors.get('areaNotEmptyWhenOperatorNotNull') }}
                                    </v-alert>
                                </v-col>
                                <v-col>
                                    <v-autocomplete
                                        v-model="form.city"
                                        :items="cities"
                                        item-value="id"
                                        item-text="name"
                                        label="Город"
                                        :clearable="true">
                                    </v-autocomplete>
                                    <v-alert v-if="form.errors.has('city')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('city') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-textarea data-test="field-problem" auto-grow v-model="form.problem" label="Проблема"></v-textarea>
                                    <v-alert v-if="form.errors.has('problem')" dense outlined type="error" :icon="false">
                                        {{ form.errors.get('problem') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="score && score.problemDescription" class="mb-4">
                                <v-col>
                                    <v-textarea auto-grow readonly filled rows="1"
                                                style="font-size: 12px"
                                                :value="score.problemDescription"
                                                label="Описание проблемы от ИИ"
                                                hint="Формируется и обновляется автоматически по мере накопления данных о клиенте"
                                                persistent-hint>
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row v-if="form.wishes && form.wishes.length" class="pb-3">
                                <v-col>
                                    <div class="text-caption grey--text mb-2">Детали обращения</div>
                                    <v-chip-group column>
                                        <v-chip
                                            v-for="(wish, i) in form.wishes"
                                            :key="i"
                                            color="orange lighten-4"
                                            text-color="orange darken-4"
                                            small
                                            label>
                                            {{ wish }}
                                        </v-chip>
                                    </v-chip-group>
                                </v-col>
                            </v-row>
                            <v-row v-if="form.budget" class="pb-3">
                                <v-col>
                                    <div class="text-caption grey--text mb-2">Ориентировочный бюджет</div>
                                    <v-chip
                                        color="green lighten-4"
                                        text-color="green darken-4"
                                        small
                                        label>
                                        {{ form.budget }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" xl="3">

                        </v-col>
                    </v-row>
                    <v-alert v-if="form.errors.any()" dense outlined type="error" :icon="false">
                        Исправьте ошибки
                    </v-alert>
                    <v-alert v-if="form.errors.has('error')" dense outlined type="error" :icon="false">
                        {{ form.errors.get('error') }}
                    </v-alert>
                    <div v-show="!form.busy">
                        <v-btn data-test="form-save-stay" large color="green" @click="request ? update(false) : save(false)">
                            Сохранить
                        </v-btn>
                        <v-btn data-test="form-save" large color="green" @click="request ? update(true) : save(false)" class="ml-4">
                            Сохранить и закрыть
                        </v-btn>
                    </div>
                    <v-progress-circular v-show="form.busy" indeterminate color="primary"></v-progress-circular>
                </form>
            </v-card-text>
        </v-card>
        <ScoreDetailDialog v-if="request"
                           :dialog-visible="dialog.scoreDetail.modal"
                           :request-id="request.id"
                           @close="dialog.scoreDetail.modal = false"
                           @recomputed="fetchScore()">
        </ScoreDetailDialog>
        <div class="my-10">
            <RequestDoubles
                v-if="request?.userPhone"
                :title="`Заявки клиента с номером: ${request.userPhone}`"
                :filter="{ cleanPhone: request.cleanPhone, isDoubles: true, showForOperatorsWithoutPermissions: true }"
                :exclude="[request.id]">
            </RequestDoubles>
            <RequestDoubles
                v-if="request?.additionalUserPhone"
                :title="`Заявки клиента с номером: ${request.additionalUserPhone}`"
                :filter="{ cleanPhone: request.cleanAdditionalUserPhone, showForOperatorsWithoutPermissions: true }"
                :exclude="[request.id]">
            </RequestDoubles>
        </div>
        <CallsGrid
            v-if="request && $helper.permission.canSeeCalls(user)"
            :title="`Вызовы для номера: ${userPhones}`"
            :filter="{ clientPhones: [request.cleanPhone, request.cleanAdditionalUserPhone] }">
        </CallsGrid>
        <RequestComments v-if="request" :id="request.id"></RequestComments>
        <RequestAnswers v-if="request && $helper.permission.canSeeRequestAnswers(user)" :request="request"
                        :areas="areas"></RequestAnswers>
        <v-card v-if="$helper.isUserRole(user, 'ADMIN') && (attributionRows.length || quizRows.length)" class="mt-4">
            <v-card-title class="text-subtitle-1">Откуда заявка</v-card-title>
            <v-card-text>
                <v-simple-table v-if="attributionRows.length" dense>
                    <tbody>
                    <tr v-for="row in attributionRows" :key="row.label">
                        <td class="grey--text" style="width: 180px">{{ row.label }}</td>
                        <td style="word-break: break-all">{{ row.value }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <div v-if="quizRows.length" class="mt-3">
                    <div class="text-caption grey--text mb-1">Ответы квиза</div>
                    <v-chip v-for="row in quizRows" :key="row.label" small label class="mr-2 mb-2">
                        {{ row.label }}: {{ row.value }}
                    </v-chip>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {Form} from '../_helpers/_form';
import RequestService from "../_services/RequestService";
import AiService from "../_services/AiService";
import {mapState} from 'vuex';
import AppointmentDialog from "./appointments/AppointmentDialog";
import RequestComments from "./comments/RequestComments";
import CallsGrid from "../calls/CallsGrid";
import RequestAnswers from "./answers/RequestAnswers";
import ScoreDetailDialog from "../ai/ScoreDetailDialog";

export default {
    name: "RequestForm",
    components: {
        RequestAnswers, ScoreDetailDialog,
        CallsGrid, RequestDoubles: () => import('././RequestGrid'), RequestComments, AppointmentDialog
    },
    props: {
        page: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: this.page.request
                ? new Form(this.page.request)
                : new Form({}),
            sources: [],
            states: [], //only manual driven states are stored here
            allStates: [],
            failureReasons: [],
            operators: [],
            counterparts: [],
            subdivisions: [],
            request: this.page.request,
            areas: this.page.areas,
            cities: this.page.cities,
            loading: false,
            score: null,
            dialog: {
                scoreDetail: {
                    modal: false
                },
                cancelAppointment: {
                    modal: false,
                    failureReason: null,
                    failureComment: null
                }
            }
        }
    },
    methods: {
        fetch() {
            this.fetchSources();
            this.fetchStates();
            this.fetchFailureReasons();
            this.fetchOperators();
            this.fetchCounterparts();
            if (this.$helper.permission.canChangeSubdivision(this.user)) {
                this.fetchSubdivisions();
            }
        },
        fetchFailureReasons() {
            RequestService.getFailureReasons().then(data => {
                this.failureReasons = data;
            });
        },
        isFailureState(requestState) {
            return ['FAILURE', 'NOT_CAME', 'CANCEL_ZAPIS', 'PULL_OFF'].includes(requestState);
        },
        fetchStates() {
            let data = this.page.states;
            this.allStates = data;
            data = data.filter(state => {
                return !(state.manualDriven !== 'true' && this.form.state !== state.value);
            });
            data = data.filter(state => {
                return !(!this.$helper.permission.canSetState(this.user, state) && this.form.state !== state.value);
            });
            this.states = data;
        },
        fetchSubdivisions() {
            this.subdivisions = this.page.subdivisions;
        },
        fetchSources() {
            this.sources = this.page.sources;
        },
        fetchOperators() {
            this.operators = this.page.operators;
        },
        fetchCounterparts() {
            this.counterparts = this.page.counterparts;
        },
        save() {
            RequestService.create(this.form).then(() => {
                this.$router.push('/');
            });
        },
        update(needToExit) {
            RequestService.update(this.request.id, this.form).then(() => {
                if (needToExit) {
                    this.$emit('closeAndUpdate');
                } else {
                    this.$emit('updated');
                }
            });
        },
        cancelAppointment() {
            const dto = {
                failureReason: this.dialog.cancelAppointment.failureReason,
                failureComment: this.dialog.cancelAppointment.failureComment
            };
            RequestService.cancelAppointment(this.request.id, dto).then(() => {
                this.dialog.cancelAppointment.modal = false;
                this.$emit("closeAndUpdate");
            });
        },
        approveAppointment() {
            RequestService.approveAppointment(this.request.id).then(() => {
                this.request.appointmentApproved = true;
                this.$emit("fetchGrid");
            });
        },
        cancelApproveAppointment() {
            RequestService.cancelApproveAppointment(this.request.id).then(() => {
                this.request.appointmentApproved = false;
                this.$emit("fetchGrid");
            });
        },
        isManualDrivenState(requestState) {
            let state = this.allStates.find(v => v.value === requestState);
            return state.manualDriven === 'true' || state.value === 'NEW';
        },
        onAppointmentAdd() {
            this.$emit("closeAndUpdate");
        },
        onChangeState(state) {
            if (state === 'RECALL') {
                this.$emit('recallSelected')
            }
        },
        fetchScore() {
            if (!this.request) {
                return;
            }
            AiService.getRequestScore(this.request.id).then(data => {
                this.score = data;
            }, () => {
                this.score = null;
            });
        }
    },
    computed: {
        ...mapState(['user']),
        userPhones() {
            return [this.request.userPhone, this.request.additionalUserPhone].filter(x => !!x).join(', ');
        },
        // метки и форма заявки с сайта (только чтение, приходят из /api/v1/apiClients)
        attributionRows() {
            const a = this.request && this.request.attribution;
            if (!a) {
                return [];
            }
            return [
                {label: 'Источник', value: [a.utmSource, a.utmMedium].filter(x => !!x).join(' / ')},
                {label: 'Кампания', value: a.utmCampaign},
                {label: 'Ключевая фраза', value: a.utmTerm},
                {label: 'Объявление', value: a.utmContent},
                {label: 'Страница входа', value: a.landingPage},
                {label: 'Форма', value: a.formType},
                {label: 'А/Б-вариант', value: a.abVariant}
            ].filter(row => !!row.value);
        },
        quizRows() {
            const labels = {direction: 'Направление', stage: 'Стадия', urgency: 'Срочность'};
            const answers = (this.request && this.request.quizAnswers) || {};
            return Object.keys(answers).map(key => ({label: labels[key] || key, value: answers[key]}));
        }
    },
    created() {
        if (this.request && this.request.id) {
            this.$helper.saveViewedEntity('requests.viewed', this.request.id.toString(), this.$ls)
        }
        this.fetch();
        if (this.$helper.permission.canSeeScore(this.user) && !(this.request && this.request.scoringEnabled === false)) {
            this.fetchScore();
        }
        this.unsubscribeRequestFormActions = this.$store.subscribeAction((action) => {
            if (action.type === 'scoreUpdated' && this.request
                && (action.payload.requestId === this.request.id
                    || (this.request.cleanPhone && action.payload.cleanPhone === this.request.cleanPhone))) {
                this.score = action.payload;
                this.request.scorePending = false;
            }
        });
    },
    beforeDestroy() {
        if (this.unsubscribeRequestFormActions) {
            this.unsubscribeRequestFormActions();
        }
    }
}
</script>

<style lang="scss">

</style>
